import ApiService from '@/utils/ApiService'
import Swal from 'sweetalert2'
import Vue from 'vue'

export default async function remove (id, successCallback = false, failureCallback = () => {}, data = {}) {
  let decision = true
  if (successCallback) {
    decision = await Swal({
      title: Vue.prototype.$lang.t('notifications.deleteTitle'),
      type: 'question',
      showConfirmButton: true,
      confirmButtonText: Vue.prototype.$lang.t('buttons.yes'),
      showCancelButton: true,
      cancelButtonText: Vue.prototype.$lang.t('buttons.cancel')
    })
  }
  if (decision) {
    const response = await new ApiService(id).del(data)
    if (response) {
      successCallback()
    } else {
      failureCallback()
    }
  } else {
    failureCallback()
  }
}
